import Button from "components/dashboard/forms/button/Button";
import React, { useState } from "react";
import { CourseServices } from "services/courses";
import { toast } from "react-toastify";

// import Profile from '../Profile'

export const DiscoverAllCard = ({
  id,
  thumbnail,
  tutor,
  subCategory,
  title,
  handleViewClick,
}) => {
  const handleCardClick = () => {
    handleViewClick(id);
  };
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setLoading] = useState(false);
  const token = JSON.parse(
    sessionStorage.getItem("token") || "{}"
  );
  const enrolCourses = async () => {
    const courseId = JSON.parse(
      localStorage.getItem("#enrolCourse") || "{}"
    );
    console.log(courseId)

    setLoading(true);
    try {
      const response = await CourseServices.enrollCourse(token,courseId);
      // console.log("fetch event", response);
      if (response.data.status === "success") {
        // const res = response.data.data.details;
        toast.success(response.data.data.message || "succesfully errolled");
        // setCourses(res?.rows);
        setLoading(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  return (
    <div
      className=" bg-white p-3 rounded-md flex shadow-sm flex-col gap-2"
      key={id}
    >
      <div className="rounded-lg">
        <img
          src={thumbnail}
          alt="course-img"
          className="h-[113px] w-full object-cover rounded-lg"
        />
      </div>
      <button className="bg-primary w-fit px-2 py-1 text-blueColor text-[8px] font-medium rounded-md">
        {subCategory}
      </button>
      <p className="font-semibold text-[14px] leading-[20px]">{title}</p>
      <div className="flex justify-between">
        <div className="flex gap-2">
          <div className="w-6 h-6 rounded-full">
            {/* <img
              src={profileImg}
              alt="profile"
              className="w-full h-full object-cover rounded-full "
            /> */}
          </div>
          <div className="flex flex-col justify-between text-[8px]">
            <h2 className="text-neutral  font-semibold">{tutor}</h2>
            <p className="">Instructor</p>
          </div>
        </div>

        <div className=" w-fit">
          <Button
            onClick={() => {
              handleCardClick();
              enrolCourses();
            }}
          >
            Enroll
          </Button>
        </div>
      </div>
    </div>
  );
};
